import { useSearchMakesApiV1VehiclesMakesGet } from '#/shared/api/generated/shipment/theCargoShipment'
import type { MakeSuggestion } from '#/shared/api/generated/shipment/models'
import { useDebouncedValue } from '#/shared/lib/hooks'

export const MAKE_MIN_QUERY_LENGTH = 2
const DEBOUNCE_MS = 250
const SUGGEST_LIMIT = 20

export function useMakeSearch(query: string, options?: { enabled?: boolean }) {
  const debouncedQuery = useDebouncedValue(query.trim(), DEBOUNCE_MS)
  const hasQuery = debouncedQuery.length >= MAKE_MIN_QUERY_LENGTH
  const enabled = (options?.enabled ?? true) && hasQuery
  const { data, isFetching } = useSearchMakesApiV1VehiclesMakesGet(
    { q: debouncedQuery, limit: SUGGEST_LIMIT },
    { query: { enabled } },
  )
  const items: MakeSuggestion[] = data?.data ?? []
  return {
    items,
    isLoading: isFetching && enabled,
    needsMoreInput: !hasQuery,
  }
}
